/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './asset-comments.scss';
import assetCommentsTemplate from './asset-comments.tpl.html';

/* eslint-disable import/no-unresolved, import/default */

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.assetComments', [])
    .directive('agAssetComments', AssetComments)
    .filter('linebreaks', lineBreak)
    .name;


/*@ngInject*/
function AssetComments() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: AssetCommentsController,
        controllerAs: 'vm',
        templateUrl: assetCommentsTemplate
    };

}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function AssetCommentsController($scope, $timeout, $translate, $mdDialog, types, agTypes, agUtils, userService, attributeService) {

    let vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.assetId = null;
    vm.assetName = null;
    vm.allowCommentsEditing = true;

    var user = userService.getCurrentUser();
    if (user.authority === 'CUSTOMER_USER') {
        var userAdditionalInfo = userService.getCurrentUserDetails().additionalInfo;
        if (userAdditionalInfo.readOnly) {
            vm.allowCommentsEditing = false;
        }
    }

    vm.sendComment = sendComment;
    vm.editComment = editComment;
    vm.deleteComment = deleteComment;
    vm.enterCommentEditMode = enterCommentEditMode;
    vm.cancelCommentEditMode = cancelCommentEditMode;

    if (vm.ctx.currentWidgetType == agTypes.siloWidgetType.siloComments) {
        vm.helpPageAction = agUtils.createHelpActionConfig("agSilo", "ag.docsPageSections.silo-comments");
    } else if (vm.ctx.currentWidgetType == agTypes.siloGroupWidgetType.siloGroupComments) {
        vm.helpPageAction = agUtils.createHelpActionConfig("agSiloGroup", "ag.docsPageSections.silo-group-comments");
    } else if (vm.ctx.currentWidgetType == agTypes.weatherStationWidgetType.weatherStationComments) {
        vm.helpPageAction = agUtils.createHelpActionConfig("agWeatherStation", "ag.docsPageSections.weather-station-settings");
    }

    $scope.$watch('vm.ctx', function () {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;

            vm.assetId = null;
            vm.assetName = null;
            if (vm.ctx.stateController) {
                var params = vm.ctx.stateController.getStateParams();
                //vm.assetId = vm.ctx.stateController.getStateParams().entityId;
                //vm.assetName = vm.ctx.stateController.getStateParams().entityName;
                vm.assetId = params.entityId;
                vm.assetName = params.entityLabel || params.entityName;
            }
            loadComments();
            $scope.$watch(function () {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiloId, prevSiloId) {
                    if (newSiloId && !angular.equals(newSiloId, prevSiloId)) {
                        vm.assetId = newSiloId;
                        //vm.assetName = vm.ctx.stateController.getStateParams().entityName;
                        params = vm.ctx.stateController.getStateParams();
                        vm.assetName = params.entityLabel || params.entityName;
                        loadComments();
                    }
                }
            );
        }
    });

    $scope.$watch(function () {
        return vm.assetName ? vm.assetName : null;
    }, function (title) {
        if (vm.ctx) {
            vm.ctx.widgetTitle = $translate.instant('ag.asset.comments') + ': ' + title;
        }
    });

    function loadComments() {
        vm.loading = true;
        vm.commentEditMode = false;
        vm.newComment = "";

        attributeService.getEntityAttributesValues(vm.assetId.entityType, vm.assetId.id, types.attributesScope.server.value, ["comments"]).then(
            function success(data) {
                vm.assetComments = data.length ? angular.fromJson(data[0].value) : [];
                vm.loading = false;
            },
            function fail() {
                vm.loading = false;
            }
        );
    }

    function sendComment() {
        if (vm.newComment) {
            vm.sending = true;
            var comment = {};
            comment.timestamp = new Date().getTime();
            comment.commentValue = vm.newComment;
            comment.userName = (user.firstName || user.lastName) ? user.firstName + " " + user.lastName : $translate.instant('ag.asset.anonymous');
            vm.assetComments.unshift(comment);
            var editedComments = angular.toJson(vm.assetComments);
            vm.newComment = "";

            attributeService.saveEntityAttributes(vm.assetId.entityType, vm.assetId.id, types.attributesScope.server.value, [{
                key: "comments",
                value: editedComments
            }]).then(
                function success() {
                    vm.sending = false;
                },
                function fail() {
                    vm.sending = false;
                }
            );
        }
    }

    function editComment() {
        if (vm.editedCommentValue) {
            vm.editedComment.commentValue = vm.editedCommentValue;
            if (vm.originalCommentvalue != vm.editedComment.commentValue) {
                vm.editedComment.edited = true;
            } else {
                vm.commentEditMode = false;
                return;
            }
            vm.commentEditMode = false;
            vm.sending = true;

            var editedComments = angular.toJson(vm.assetComments);
            attributeService.saveEntityAttributes(vm.assetId.entityType, vm.assetId.id, types.attributesScope.server.value, [{
                key: "comments",
                value: editedComments
            }]).then(
                function success() {
                    vm.sending = false;
                },
                function fail() {
                    vm.sending = false;
                }
            );
        }
    }

    function deleteComment($event, comment) {
        if ($event) {
            $event.stopPropagation();
        }
        vm.commentEditMode = false;

        var title = $translate.instant('ag.asset.delete-comment-title');
        var content = $translate.instant('ag.asset.delete-comment-text');

        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title(title)
            .htmlContent(content)
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
            vm.sending = true;
            var index = vm.assetComments.indexOf(comment);
            vm.assetComments.splice(index, 1);

            var editedComments = angular.toJson(vm.assetComments);
            attributeService.saveEntityAttributes(vm.assetId.entityType, vm.assetId.id, types.attributesScope.server.value, [{
                key: "comments",
                value: editedComments
            }]).then(
                function success() {
                    vm.sending = false;
                },
                function fail() {
                    vm.sending = false;
                }
            );
        });
    }

    function enterCommentEditMode(comment) {
        vm.editedComment = comment;
        vm.commentEditMode = true;
        vm.originalCommentvalue = comment.commentValue;
        vm.editedCommentValue = comment.commentValue;
        $timeout(function () {
            var editPanel = angular.element("#asset-comment-edit");
            editPanel.focus();
        });
    }

    function cancelCommentEditMode() {
        vm.commentEditMode = false;
    }
}

/*@ngInject*/
function lineBreak() {
    return function (text) {
        return text.replace(/\n/g, "<br>");
    }
}